import { MainPropertyType } from '@aloft/toolkit-shared';

type OptionType = { value: MainPropertyType; label: string };

export function getPropertyTypeOptions({
  primaryPropertyType,
}: {
  primaryPropertyType: MainPropertyType;
}): OptionType[] {
  if (primaryPropertyType === 'multiFamily') {
    return [
      {
        value: 'multiFamily',
        label: 'Multi-Family (1025)',
      },
    ];
  }

  if (primaryPropertyType === 'manufacturedHome') {
    return [
      {
        value: 'singleFamilyResidence',
        label: 'Single Family (forms 1004, 2055, etc.)',
      },
      {
        value: 'manufacturedHome',
        label: 'Manufactured Home (1004C)',
      },
    ];
  }

  return [
    {
      value: 'singleFamilyResidence',
      label: 'Single Family (forms 1004, 2055, etc.)',
    },
  ];
}
